import React from 'react';
import PT from 'prop-types';
import { I18nProvider } from '@procore/core-react';
import i18n from '../i18n';
import { AppContextProvider } from '@/react/context/AppContext';
import { SearchProvider } from '@/react/context/SearchContext';
import MarketplaceListing from './MarketplaceListing';
import MarketplaceListingProfessional from './MarketplaceListingProfessional';

const MarketplaceListingContainer = ({
  listing,
  header,
  professionalMarketplace,
}) => {
  // Use Professional Marketplace UI if feature flag is enabled
  const ListingComponent = professionalMarketplace
    ? MarketplaceListingProfessional // NEW: Professional Marketplace UI
    : MarketplaceListing; // OLD: Legacy UI (will be removed after release)

  return (
    <I18nProvider locale={i18n.locale} translations={i18n.translations}>
      <SearchProvider>
        <AppContextProvider
          listing={listing}
          header={header}
          professionalMarketplace={professionalMarketplace}
        >
          <ListingComponent />
        </AppContextProvider>
      </SearchProvider>
    </I18nProvider>
  );
};

MarketplaceListingContainer.propTypes = {
  header: PT.shape({}).isRequired,
  listing: PT.shape({
    apps: PT.shape([]),
    query: PT.string,
    categories: PT.shape([]),
  }).isRequired,
  professionalMarketplace: PT.bool,
};

export default MarketplaceListingContainer;
